import React, { useEffect } from 'react';
import { Box, TableBody } from '@mui/material';
import {
  MainContainer,
  HeaderContainer,
  PageTitle,
  StyledTableContainer,
  StyledTable,
  StyledTableHead,
  StyledTableRow,
  StyledTableCell
} from '../styles';
import { useBreadcrumb } from '../../../context/BreadcrumbContext';
import { useSidebar } from '../../../context/SidebarContext';
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch } from '../../../store';
import { fetchSystemModules } from '../../../modules/superadmin';
import {
  selectSystemModules,
  selectSystemModulesLoading
} from '../../../modules/superadmin/selectors';
import { SystemModule } from '../../../modules/superadmin/types';

const SystemModulesPage: React.FC = () => {
  const { setActivePage } = useSidebar();
  const { setPath, setIsShow } = useBreadcrumb();
  const dispatch = useDispatch<AppDispatch>();

  const modules = useSelector(selectSystemModules);
  const loading = useSelector(selectSystemModulesLoading);

  useEffect(() => {
    setActivePage('system-modules');
    setPath([
      { title: 'Super Admin', path: '/super-admin' },
      { title: 'System Modules', path: '/super-admin/system-modules' },
    ]);
    setIsShow(true);
    dispatch(fetchSystemModules());
  }, [setActivePage, setPath, setIsShow, dispatch]);

  return (
    <Box>
      <MainContainer>
        <HeaderContainer>
          <PageTitle variant="h6">System Modules</PageTitle>
        </HeaderContainer>

        <StyledTableContainer>
          <StyledTable>
            <StyledTableHead>
              <StyledTableRow>
                <StyledTableCell>ID</StyledTableCell>
                <StyledTableCell>Name</StyledTableCell>
                <StyledTableCell>Slug</StyledTableCell>
                <StyledTableCell>Type</StyledTableCell>
                <StyledTableCell>Description</StyledTableCell>
              </StyledTableRow>
            </StyledTableHead>
            <TableBody>
              {Array.isArray(modules) && modules.length > 0 ? (
                modules.map((module: SystemModule) => (
                  <StyledTableRow key={module.module_id}>
                    <StyledTableCell>{module.module_id}</StyledTableCell>
                    <StyledTableCell>{module.module_name}</StyledTableCell>
                    <StyledTableCell>{module.module_slug}</StyledTableCell>
                    <StyledTableCell>{module.module_type}</StyledTableCell>
                    <StyledTableCell>{module.module_description}</StyledTableCell>
                  </StyledTableRow>
                ))
              ) : (
                <StyledTableRow>
                  <StyledTableCell colSpan={5} align="center">
                    {loading ? 'Loading...' : 'No modules found.'}
                  </StyledTableCell>
                </StyledTableRow>
              )}
            </TableBody>
          </StyledTable>
        </StyledTableContainer>
      </MainContainer>
    </Box>
  );
};

export default SystemModulesPage;
